import React, { useState } from "react";
import AccordianPatientInformation from "./AccordianPatientInformation";
import AccordianHealthMedication2 from "./AccordianHealthMedication2";
import AccordianNestleOmegaPlus from "./AccordianNestleOmegaPlus";
import AccordianFoodLog from "./AccordianFoodLog";
import AccordianConsultationDetail from "./AccordianConsultationDetail";
import ModalMoodLog from "./ModalMoodLog";
import ModalAssessment from "./ModalAssessment";
import { Accordion } from "react-bootstrap";
import ProfileImage from "./ProfileImage";
import { getPatientName } from "helpers/teleconsult.helper";
import moment from "moment";
import IconVideo from "assets/icons/video-pink-icon.svg";
import ChatSessionService from "services/chat-session.service";
import IconVideoLink from "assets/icons/VideoLink.svg";
import IconStar from "assets/icons/StarIcon.svg";
import { Form } from "react-bootstrap";

function ChatSessionDetails({ chat }) {
  const memoizedChat = React.useMemo(() => chat, [chat]);
  const [isAiPowered, setIsAiPowered] = useState(chat.is_ai_powered);

  //2024-07-30 Joe: Bring back this url thing because KJ say some doctor need this to copy link to another device
  const VideoLink = () => {
    function copy() {
      const el = document.createElement("input");
      el.value = chat.video_session.patient_twilio_video_link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }

    return (
      <div className="video-link-container">
        <div className="d-flex align-items-center">
          <img src={IconVideoLink} alt="video-link" />
          <span>Video Session URL</span>
        </div>
        <span onClick={copy} className="copy">
          COPY
        </span>
      </div>
    );
  };

  const showVideoCreditRemaining = chat.is_premium_plus;

  const RemainingCredit = (params) => {
    const credit =
      params.type === "mental"
        ? chat?.mental_video_credit_remaining
        : chat?.video_credit_remaining;

    switch (credit) {
      case 0:
        return <div className="fw-300">No session left</div>;
      case null:
        return <div className="fw-300">Unlimited sessions left</div>;
      default:
        return <div className="fw-300">{credit} sessions left</div>;
    }
  };

  const VideoCreditRemainingBadge = () => {
    return (
      <div className="d-flex justify-content-center mb-2">
        <div className="badge credit-remaining">
          {chat?.video_credit_remaining === 0 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M5.47415 0C2.45575 0 0 2.4673 0 5.5C0 8.5327 2.4673 11 5.5 11C8.5327 11 11 8.5327 11 5.5C11 2.4673 8.52115 0 5.47415 0ZM6.05 8.25H4.95V7.15H6.05V8.25ZM6.05 6.05H4.95V2.75H6.05V6.05Z"
                fill="#EB2726"
              />
            </svg>
          )}
          {chat?.is_premium_plus && chat?.is_mental_health_session ? (
            <div className="fw-600">Mental Health Coach:</div>
          ) : (
            <div className="fw-600">Health Coach:</div>
          )}

          <RemainingCredit
            type={
              chat?.is_premium_plus && chat?.is_mental_health_session
                ? "mental"
                : ""
            }
          />
        </div>
      </div>
    );
  };

  const AiniChatSummary = () => {
    return (
      <div className="chat-summary-container">
        <div className="chat-summary-title"><img src={IconStar} alt="aini-chat-summary" /> AINI CHAT SUMMARY</div>
        <div className="chat-summary-content">{chat.ai_mental_health_chat_summary}</div>
      </div>
    );
  }

  const name = (chat) => {
    if (chat?.appointment_info && !chat?.appointment_info?.is_me) {
      return (
        <div className="mb-2 dependent text-capitalize">
          {getPatientName(chat)} <i>(dependent)</i>
          <div className="info">Dependent of {chat.payment.payer.fullname}</div>
        </div>
      );
    } else {
      return <div className="mb-2 text-capitalize">{getPatientName(chat)}</div>;
    }
  };

  const notifyUser = (chat) => {
    const params = {
      user_id: chat.user_info.id,
      room: chat.video_session.twilio_video_room,
    };
    ChatSessionService.notifyUser(params).then(
      (data) => {},
      (error) => {}
    );
  };
  const zmNotifyUser = (chat) => {
    const params = {
      user_id: chat.user_info.id,
      teleconsult_on_demand_id: chat?.teleconsult_on_demand_id,
    };
    ChatSessionService.notifyUser(params).then(
      (data) => {},
      (error) => {}
    );
  };

  const updateIsAiPowered = (status) => {
    const params = {
      is_ai_powered: status,
    };

    ChatSessionService.updateIsAiPowered(chat.id, params).then((data) => {
      setIsAiPowered(data.status);
    });
  };
  return (
    <div className="chat-session-details">
      <div className="text-center patient-main">
        <div className="chat-img">
          <ProfileImage chat={chat} />
        </div>
        <div className="patient-name">
          <>{name(chat)}</>
          {chat.is_premium_plus &&
            chat?.premium_plus?.package === "ninety_days_mom" && (
              <div className="ninety-days-mom rounded-pill mb-2">
                90days Mum Journey
              </div>
            )}
          {chat.user_info.corporate && (
            <div className="corporate"> {chat.user_info.corporate.name} </div>
          )}
        </div>

        {chat.video_session &&
          chat.hasStarted &&
          !(new moment().unix() > chat.video_session.end_at) && (
            <>
              {chat?.teleconsult_on_demand_id ? (
                <div>
                  <a
                    href={`/eb/video?on_demand_id=${chat?.teleconsult_on_demand_id}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => zmNotifyUser(chat)}
                  >
                    <button className="btn btn-danger rounded-pill rejoin-video-call-session">
                      Rejoin Call
                    </button>
                  </a>
                </div>
              ) : (
                <div>
                  <a
                    href={chat.video_session.twilio_video_link}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => notifyUser(chat)}
                  >
                    <button className="btn btn-danger rounded-pill start-video-call-btn">
                      <img src={IconVideo} alt="video-icon" /> Start Video Call
                    </button>
                  </a>
                  <VideoLink />
                </div>
              )}
            </>
          )}
        {showVideoCreditRemaining && <VideoCreditRemainingBadge />}
        {chat?.ai_mental_health_chat_summary && <AiniChatSummary />}
        {chat.is_nutrition_session && (
          <Form className="ai-powered-form">
            <div className="d-flex justify-content-center align-items-center">
              <Form.Check.Label
                htmlFor="ai-powered-switch"
                className={`label ${isAiPowered ? "checked" : "unchecked"}`}
              >
                AI Powered
              </Form.Check.Label>
              <Form.Check
                type="switch"
                id="ai-powered-switch"
                defaultChecked={isAiPowered}
                onChange={(e) => updateIsAiPowered(e.target.checked)}
              />
            </div>
          </Form>
        )}
        <hr
          style={{
            color: "#D6D6D6",
            height: 0.5,
            margin: "20px 0",
          }}
        />
      </div>
      <div>
        <Accordion defaultActiveKey="0" className="accordions-container">
          <AccordianPatientInformation chat={chat} />
          {(chat.is_nutrition_session || chat.is_mental_health_session) && (
            <AccordianHealthMedication2 chat={chat} />
          )}

          {(!chat.is_nutrition_session && !chat.is_mental_health_session) && (
            <AccordianConsultationDetail chat={chat} />
          )}
          {chat.nestle_omega_plus && (
            <AccordianNestleOmegaPlus
              nestle_omega_plus={chat.nestle_omega_plus}
            />
          )}
          {chat.is_mental_health_session && (
            <>
              <ModalMoodLog chat={memoizedChat} />
              <ModalAssessment chat={memoizedChat} />
            </>
          )}
          {chat.is_nutrition_session && <AccordianFoodLog chat={chat} />}
        </Accordion>
      </div>
    </div>
  );
}

export default ChatSessionDetails;
